import axios from 'axios';

const path = 'user';

export default {
  getCurrent: () => axios.get(`/api/${path}/current`, { withCredentials: true }),
  getAll: (abteilung = null) => axios.get(`/api/${path}/`, { params: { abteilung }, withCredentials: true }),
};
